import template from './location-print.html';
import controller from './print.controller';
import './print.scss';

let printComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default printComponent;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/locations/print/print.component.js